(function commentsQuestionsModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const commentsElementOnPage = document.querySelector('[data-comments-textarea]');
  const commentsCharacterLimit = commentsElementOnPage ? commentsElementOnPage.maxLength : 200;
  const buttonsContainer = document.querySelector('[data-comments-buttons]');
  const submitRequestButton = document.querySelector('[data-comments-submit-button]');

  // Sanitize input to prevent injections before encoding
  const sanitizeInput = (input) => {
    // Remove script tags and potentially dangerous characters
    return input.replace(/<script.*?>.*?<\/script>/gi, '')
      .replace(/[<>]/g, '');
  };

  /**
   * Update the modal url with commentsElementOnPage value
   * even if the modal already exists
   *
   * @function
   * @returns {void}
   */
  //
  const updateModalUrlWithComments = () => {
    if (!commentsElementOnPage || !submitRequestButton) {
      return;
    }
    const baseUrl = submitRequestButton.getAttribute('data-modal-url').split('&leadcomments=')[0];
    const sanitizedValue = sanitizeInput(commentsElementOnPage.value.trim());
    const encoded = encodeURIComponent(sanitizedValue);
    const fullUrl = baseUrl + '&leadcomments=' + encoded;

    // Update the modal url
    submitRequestButton.setAttribute('data-modal-url', fullUrl);
  };

  /**
  * Update the modal input with commentsElementOnPage value
  * only if the modal exists (has been loaded by the url)
  *
  * @function
  * @returns {void}
  */
  //
  const updateModalInputWithComments = () => {
    const commentsInputOnModal = document.querySelector('[data-comments-input-modal]');
    if (!commentsInputOnModal) {
      return;
    }
    const sanitizedValue = sanitizeInput(commentsElementOnPage.value.trim());

    // Update the modal input value
    commentsInputOnModal.value = sanitizedValue;
  };

  /**
   * Watch the commentsElementOnPage
   *
   * @function
   * @returns {void}
   */
  //
  const commentsElementOnPageWatcher = () => {
    const closestWrapper = commentsElementOnPage.closest('.nhs-c-input__wrapper');

    // Add or remove error class based on maxlength reached
    if (commentsElementOnPage.value.length >= commentsCharacterLimit) {
      closestWrapper.classList.add('nhs-c-input__wrapper--error');
    } else {
      closestWrapper.classList.remove('nhs-c-input__wrapper--error');
    }

    // Show buttonsContainer if textarea is cleared, hide if user types
    if (buttonsContainer) {
      if (commentsElementOnPage.value.length === 0) {
        buttonsContainer.removeAttribute('hidden');
      } else {
        buttonsContainer.setAttribute('hidden', 'hidden');
      }
    }

    // Update modal url and input
    updateModalUrlWithComments();
    updateModalInputWithComments();
  };

  /**
  * Handle comments button presses
  *
  * @function
  * @returns {void}
  */
  //
  const commentsButtonClickHandler = (event) => {
    const target = event.target;
    const btn = target.closest('button');
    if (!btn) {
      return;
    }
    commentsElementOnPage.value = btn.textContent.trim();

    // Hide buttonsContainer after selection
    buttonsContainer.setAttribute('hidden', 'hidden');

    // Update modal url and input
    updateModalUrlWithComments();
    updateModalInputWithComments();
  };

  /**
   * Initialize the watcher for commentsElementOnPage
   *
   * @function
   * @returns {void}
   */
  //
  const watchCommentsElementOnPage = () => {
    if (!commentsElementOnPage) {
      return;
    }
    // Remove previous handler if it exists to prevent duplicates
    commentsElementOnPage.removeEventListener('input', commentsElementOnPageWatcher);
    commentsElementOnPage.addEventListener('input', commentsElementOnPageWatcher);
  };

  /**
  * Initialize comments button presses
  *
  * @function
  * @returns {void}
  */
  //
  const handleCommentsButtonsClicks = () => {
    if (!commentsElementOnPage || !buttonsContainer) {
      return;
    }
    // Remove previous handler if it exists to prevent duplicates
    buttonsContainer.removeEventListener('click', commentsButtonClickHandler);
    buttonsContainer.addEventListener('click', commentsButtonClickHandler);
  };

  watchCommentsElementOnPage();
  handleCommentsButtonsClicks();

}(window));